import React from "react";
import { Trans, useTranslation } from "react-i18next";
import WarmTierRepositorySetupText from "data-tiering/WarmTierRepositorySetupText";
import WarmTierSnapshotsText from "data-tiering/WarmTierSnapshotsText";
import { Alert } from "components/bootstrap";
import { Link, Spinner } from "components/common";
import AppConfig from "util/AppConfig";
import DataTieringRoutes from "./Routes";
import useDataTiering from "./hooks/useDataTiering";
const WarmTierReadinessInfo = () => {
  var _a;
  const { t } = useTranslation("enterprise_data_tiering");
  const { readiness } = useDataTiering();
  if (readiness.isLoading) return /* @__PURE__ */ React.createElement(Spinner, { text: t("warm_tier_readiness.fetching") });
  const introductionText = t("warm_tier_readiness.introduction");
  const alertText = () => {
    var _a2, _b, _c;
    if (!((_a2 = readiness.data) == null ? void 0 : _a2.details.supported_by_search_version)) {
      return /* @__PURE__ */ React.createElement("p", null, t("warm_tier_readiness.unsupported_version"));
    }
    if (!((_b = readiness.data) == null ? void 0 : _b.details.restored_snapshots_assignable)) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, introductionText), /* @__PURE__ */ React.createElement(WarmTierSnapshotsText, null));
    }
    if (((_c = readiness.data) == null ? void 0 : _c.details.supported_repository_types.length) === 0) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, introductionText), /* @__PURE__ */ React.createElement(WarmTierRepositorySetupText, null));
    }
    return null;
  };
  if ((_a = readiness.data) == null ? void 0 : _a.ready) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning", title: t("warm_tier_readiness.title") }, alertText(), !AppConfig.isCloud() && /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "warm_tier_readiness.guide",
      components: { pageLink: /* @__PURE__ */ React.createElement(Link, { to: DataTieringRoutes.WARM_TIER_REPOSITORIES }) }
    }
  )));
};
export default WarmTierReadinessInfo;
